module.exports = __webpack_public_path__ + "img/ring_r_i_1_0@3x.f536458c.png";